import validateImage from 'utils/validateImage'

export default validateImage
